import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Oval } from "react-loader-spinner";
import { useTranslation } from "react-i18next";

import ContactDetailsForm from "pages/profile/vendorProfile/vendorForm/contactDetails";

function EditContactDetailsInformation({ onDiscard = () => {}, onSave = () => {}, isLoading = false }) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});

  const defaultsValues = {
    permanentAddress: userDetails?.extraInformation?.contactDetails?.permanentAddress ?? "",
    currentResidenceAddress: userDetails?.extraInformation?.contactDetails?.currentResidenceAddress ?? "",
    country: userDetails?.extraInformation?.contactDetails?.country ?? "",
    phoneNumber: userDetails?.extraInformation?.contactDetails?.phoneNumber ?? "",
    homeTelephone: userDetails?.extraInformation?.contactDetails?.homeTelephone ?? "",
  };

  const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: defaultsValues,
  });

  return (
    <form className="flex flex-col self-stretch rounded-[16px] border-[1px] border-solid border-primary" onSubmit={handleSubmit(onSave)}>
      <div className="flex p-[24px] justify-between align-center self-stretch border-b border-solid border-[#E4E4E7]">
        <div className="text-[#1D1B22] font-semibold text-[24px]">{t("contactDetailsTitle")}</div>
        <div className="flex items-center gap-[12px]">
          <button type="button" onClick={onDiscard} disabled={isLoading} className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-default-color bg-white h-[46px]">
            <div className="text-base-black font-bold text-[16px] not-italic">{t("Cancel")}</div>
          </button>
          <button type="submit" disabled={isLoading} className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px]">
            <Oval height={30} width={30} color="#FFF" visible={isLoading} ariaLabel="oval-loading" secondaryColor="#FFF" strokeWidth={5} strokeWidthSecondary={3} />
            <div className="text-white font-bold text-[16px] not-italic">{t("saveChangesCta")}</div>
          </button>
        </div>
      </div>

      <ContactDetailsForm
        register={register}
        setValue={setValue}
        errors={errors}
        watch={watch}
        containerClassName="grid gap-[30px] w-full p-[24px]"
      />
    </form>
  );
}

EditContactDetailsInformation.propTypes = {
  onDiscard: PropTypes.func,
  onSave: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default EditContactDetailsInformation;

